var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "title-wrap" }, [
    _vm.titleType === 1 || _vm.titleType === "1"
      ? _c("div", { staticClass: "text-title" }, [
          _c("div", { ref: "mainTitle", staticClass: "push-title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.titleObj && _vm.titleObj.title) + "\n    "
            ),
          ]),
        ])
      : _vm.titleType === 2 || _vm.titleType === "2"
      ? _c("div", { staticClass: "img-title" }, [
          _c("div", { staticClass: "title-image-wrap" }, [
            _c("img", {
              staticClass: "title-image",
              attrs: { src: _vm.titleObj && _vm.titleObj.title_image, alt: "" },
            }),
          ]),
        ])
      : _c("div", { staticClass: "mix-title" }, [
          _c("img", {
            staticClass: "title-image",
            attrs: { src: _vm.titleObj && _vm.titleObj.title_image, alt: "" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mix-title-text" }, [
            _vm._v(_vm._s(_vm.titleObj && _vm.titleObj.title)),
          ]),
        ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "subTitle",
        staticClass: "sub-title",
        class: {
          paddinglr: _vm.titleType == 1,
          paddingwrap: _vm.titleType == 2 || _vm.titleType == 3,
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "left-wrap",
            style: { "margin-right": `${_vm.os.android ? "0.18rem" : "0"}` },
          },
          [
            _vm.titleObj.min_image
              ? _c("span", {
                  staticClass: "title_icon",
                  style: { backgroundImage: `url(${_vm.titleObj.min_image})` },
                  on: { click: _vm.goEarlyWarningLink },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "title-text",
                class: { "has-min-image": _vm.titleObj.min_image },
                on: { click: _vm.goEarlyWarningLink },
              },
              [_vm._v(_vm._s(_vm.titleObj && _vm.titleObj.push_user))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "public-time" }, [
              _vm._v(
                _vm._s(
                  _vm.formatPublicTime(_vm.titleObj && _vm.titleObj.push_time)
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.titleObj && _vm.titleObj.viewed_count
          ? _c("div", { staticClass: "view-info" }, [
              _c("div", { staticClass: "icon" }),
              _vm._v(" "),
              _c("div", { staticClass: "view-info-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.checkPreviewNum(
                        _vm.titleObj && _vm.titleObj.viewed_count
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }